<div class="wiki-overlay" (click)="$event.stopPropagation()">

  <div class="wiki-topbar">
    <div class="wiki-brand">
      <div class="wiki-brand-icon">
        <img src="/web/icon-512.png" alt="Trieon.HR" class="wiki-brand-logo" />
      </div>
      <div class="wiki-brand-text">
        <span class="wiki-brand-name">Trieon<span class="wiki-brand-accent">.HR</span></span>
        <span class="wiki-brand-sub">Help &amp; Documentation</span>
      </div>
    </div>
    <div class="wiki-topbar-meta">
      <span class="wiki-topic-pill">{{ totalTopicCount }} topics</span>
      <button class="wiki-close" (click)="closePanel.emit()" aria-label="Close documentation">
        <span class="pi pi-times"></span>
      </button>
    </div>
  </div>

  <div class="wiki-main">
    @if (wikiContentService.loadFailed()) {
      <div class="wiki-load-error">
        <span class="pi pi-exclamation-triangle"></span>
        <p>Unable to load documentation. Please refresh and try again.</p>
      </div>
    } @else if (!wikiContentService.loaded()) {
      <div class="wiki-loading">
        <span class="pi pi-spin pi-spinner"></span>
        <p>Loading documentation...</p>
      </div>
    } @else {
    <nav class="wiki-sidenav">
      <div class="wiki-nav-toolbar">
        <div class="wiki-search">
          <span class="pi pi-search wiki-search-icon"></span>
          <input
            type="search"
            class="wiki-search-input"
            [(ngModel)]="searchQuery"
            (ngModelChange)="onSearchChange()"
            placeholder="Search documentation..."
            aria-label="Search documentation topics" />
          @if (searchQuery) {
            <button type="button" class="wiki-search-clear" (click)="searchQuery = ''; onSearchChange()" aria-label="Clear search">
              <span class="pi pi-times"></span>
            </button>
          }
        </div>
      </div>

      <div class="wiki-nav-groups">
        @for (group of filteredNavGroups; track group.id) {
          <div class="nav-group">
            <div class="nav-group-label">
              <span class="pi" [ngClass]="group.icon"></span>
              {{ group.label }}
            </div>
            <ul class="nav-topics">
              @for (topic of group.topics; track topic.id) {
                <li>
                  <button
                    type="button"
                    class="nav-topic-btn"
                    [class.active]="selectedTopicId === topic.id"
                    (click)="selectTopic(topic.id)">
                    {{ topic.label }}
                  </button>
                </li>
              }
            </ul>
          </div>
        }

        @if (searchQuery && filteredNavGroups.length === 0) {
          <div class="wiki-search-empty">
            <span class="pi pi-search"></span>
            <p>No topics match "{{ searchQuery }}"</p>
          </div>
        }
      </div>
    </nav>

    <main class="wiki-content" #contentArea>
      <div class="content-inner">
        <div class="topic-breadcrumb">
          <span class="pi pi-book"></span>
          <span>{{ currentTopic.title }}</span>
        </div>

        <h1 class="topic-title">{{ currentTopic.title }}</h1>
        <p class="topic-subtitle">{{ currentTopic.subtitle }}</p>

        @if (selectedTopicId === 'setup-overview' && setupAttention.showSetupButton()) {
          <button type="button" class="wiki-setup-checklist-btn" (click)="openSetupChecklist()">
            <span class="pi pi-flag"></span>
            Open Setup Checklist
          </button>
        }

        <hr class="topic-divider" />

        @if (hasVideoSlot) {
          <div class="topic-video-wrap">
            @if (videoEmbedUrl) {
              <div class="topic-video-frame">
                <iframe
                  [src]="videoEmbedUrl"
                  [title]="currentTopic.title + ' tutorial video'"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowfullscreen
                  loading="lazy"
                  referrerpolicy="strict-origin-when-cross-origin"></iframe>
              </div>
              @if (videoCaption) {
                <p class="topic-video-caption">{{ videoCaption }}</p>
              }
            } @else {
              <div class="topic-video-placeholder" aria-label="Video placeholder">
                <span class="pi pi-play-circle"></span>
                <p class="topic-video-placeholder-title">Tutorial video</p>
                <p class="topic-video-placeholder-text">{{ videoCaption }}</p>
              </div>
            }
          </div>
        }

        <div class="topic-screenshot-wrap" [class.visible]="screenshotLoaded">
          <img
            class="topic-screenshot"
            [src]="'/wiki/' + selectedTopicId + '.png'"
            [alt]="currentTopic.title + ' screenshot'"
            (load)="onScreenshotLoad()"
            (error)="onScreenshotError()"
            (click)="openLightbox()" />
          <div class="screenshot-footer">
            <span class="screenshot-caption">{{ currentTopic.title }} — module overview</span>
            <button class="screenshot-zoom-btn" (click)="openLightbox()" title="View full size">
              <span class="pi pi-arrows-alt"></span> Expand
            </button>
          </div>
        </div>

        @for (section of currentTopic.sections; track section.id) {
          <h2 [id]="section.id" class="section-heading">{{ section.heading }}</h2>
          @if (section.lead) {
            <p class="section-lead">{{ section.lead }}</p>
          }
          <ul class="section-items">
            @for (item of section.items; track item.text) {
              <li>
                @if (item.label) {
                  <strong>{{ item.label }} </strong>
                }
                {{ item.text }}
              </li>
            }
          </ul>
        }
      </div>
    </main>

    <aside class="wiki-toc">
      <div class="toc-heading">On this page</div>
      <ul class="toc-list">
        @for (section of currentTopic.sections; track section.id) {
          <li>
            <button
              type="button"
              class="toc-link"
              [class.active]="activeSection === section.id"
              (click)="scrollTo(section.id)">
              {{ section.heading }}
            </button>
          </li>
        }
      </ul>
    </aside>
    }
  </div>

  @if (lightboxSrc) {
    <div class="screenshot-lightbox" (click)="closeLightbox()">
      <button class="lightbox-close" (click)="$event.stopPropagation(); closeLightbox()" aria-label="Close">
        <span class="pi pi-times"></span>
      </button>
      <img [src]="lightboxSrc" [alt]="currentTopic.title + ' screenshot'" (click)="$event.stopPropagation()" />
    </div>
  }

</div>
